/**
 * RevenueCat's PUBLIC SDK keys, one per till — the values the SDK is configured
 * with in every store binary and every browser, so they are not secrets and they
 * live here as the build's defaults (the same way chatv1/config.ts carries its
 * endpoints), overridable per build by VITE_RC_IOS_KEY / VITE_RC_ANDROID_KEY /
 * VITE_RC_WEB_KEY. One RevenueCat project serves dev and prod alike. For the
 * store tills, sandbox versus production is decided by the store the purchase
 * happens in, not by the key, so dev and prod builds carry the same value. The
 * WEB till is the exception: Web Billing issues a production key (rcb_…) and a
 * sandbox key (rcb_sb_…, Stripe test mode, test cards, five-minute months). The
 * production key is the committed default here; THE DEV BUILD MUST PASS THE
 * SANDBOX KEY through VITE_RC_WEB_KEY, so a test card is never tried against a
 * live Stripe account and a real card is never charged from app-dev.
 *
 * Read from the RevenueCat API (GET /v2/projects/proj8c6b9ee8/apps/{app}/public_api_keys)
 * on 2026-09-10 by avg-devapp. An empty string means "no till on this platform
 * yet": the Upgrade button does not render there (checkout.purchaseLane).
 *
 *   ios      app appcb9ad8bd84 "Avengents iOS", bundle net.avengents.app
 *   android  not created — Play cannot make the Sep 30 date
 *   web      app app3cd4b4de61 (RevenueCat Billing), Stripe: Audionyx AI Inc. (live) —
 *            production key; the sandbox key rcb_sb_AYBWBqJQFLBEYFeKCsMWvTGFj is the dev env
 */
export const RC_PUBLIC_KEYS: Readonly<Record<'ios' | 'android' | 'web', string>> = {
  ios: 'appl_sXLBDSwifxaHiZkRKSmaqGmyZUZ',
  android: '',
  web: 'rcb_UiZyTQPBNOXNwuDdlNJuMZVZpYdD',
}
